export const PLAYBACK_CONTAINER_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PlaybackContainerItemElement';
